// extracted by mini-css-extract-plugin
export default {"label":"Checkbox_label__O-SB1","input":"Checkbox_input__KAVVD","checkbox":"Checkbox_checkbox__71xI9"};